import React from 'react'
import SbcCommon from './SbcCommon';
import SbcWrapper from './SbcWrapper';

// sidebar panel for rating
export default function SbcRating({
    data,
    handleIptChange,
    handleOptions,
    handleSwitchChange,
    handleSelectChange,
    handleMultiIptChange
}) {
    return (
        <SbcWrapper>
            <SbcCommon
                data={data}
                handleIptChange={handleIptChange}
                handleMultiIptChange={handleMultiIptChange}
                handleSwitchChange={handleSwitchChange}
                handleSelectChange={handleSelectChange}
            />
        </SbcWrapper>
    )
}
